import { InfoButton } from 'components/InfoButton/InfoButton';
import arrowDown from './assets/icon-dual-arrow-down.svg';
import arrowUp from './assets/icon-dual-arrow-up.svg';
import arrows from './assets/icon-dual-arrow.svg';

export const SortableHeader = ({
  label,
  value,
  order,
  className,
  orderByColumn,
  onToggle,
  tooltip,
  isSortable = true,
}: {
  label: string;
  value: string;
  order: string;
  className?: string;
  orderByColumn: string;
  onToggle?: (value: string) => void;
  tooltip?: string;
  isSortable?: boolean;
}) => {
  const isActive = value === orderByColumn;

  return (
    <div className="flex flex-row items-center gap-2">
      <button
        className={`focus:outline-none ${className}`}
        type="button"
        onClick={() => onToggle?.(value)}>
        <div className="flex flex-row items-center gap-2">
          <div>{label}</div>
          {isSortable ? (
            isActive ? (
              <div>
                <img
                  src={order === 'asc' ? arrowUp : arrowDown}
                  alt="sorting-chevron"
                />
              </div>
            ) : (
              <img src={arrows} alt="sorting-chevron" />
            )
          ) : null}
        </div>
      </button>
      {tooltip && <InfoButton title={label} text={tooltip} />}
    </div>
  );
};
